

export default function PinchZoom(selection, zoom, zoomed){
	var isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;

	if(isMac){
		selection
			.on('wheel.zoom', wheeled)
			.on('gesturechange', gestured)
			.on('gesturestart', gesturestart)
			.on('gestureend', gestured);	
	}
	

	// var zoom = selection.property("__zoom");

	var initialScale = 1;
	function gestured(){
	    var e = d3.event;
	    zoom.scale(e.scale * initialScale)
	    zoomed()
	    e.preventDefault()
	}

	function gesturestart(){
	    initialScale = zoom.scale();
	    d3.event.preventDefault()
	}


  function location(p) {
  	var scale = zoom.scale(),
  		translate = zoom.translate()

    return [(p[0] - translate[0]) / scale, (p[1] - translate[1]) / scale];
  }

  function point(l) {
  	var scale = zoom.scale(),
  		translate = zoom.translate()
    return [l[0] * scale + translate[0], l[1] * scale + translate[1]];
  }


  function translateTo(p, l) {
  	var scale = zoom.scale(),
  		translate = zoom.translate().slice(0)

    l = point(l);
    translate[0] += p[0] - l[0];
    translate[1] += p[1] - l[1];

    zoom.translate(translate);
  }


	function wheeled(){
	    var e = d3.event;
	    e.preventDefault()
	    if(e.metaKey || e.ctrlKey){
    	  // var [x, y] = zoom.translate()
    	  var translate0 = location(d3.mouse(this))

	      zoom.scale(zoom.scale() * Math.pow(0.98, e.deltaY))

	      translateTo(d3.mouse(this), translate0);

	    } else {
	      var scale = zoom.scale();
	      var [x, y] = zoom.translate()
	      zoom.translate([
	      		x-e.deltaX , y-e.deltaY 
	      ])
	    }
	    zoomed()
	}
}


// WEBPACK FOOTER //
// ./src/react/PinchZoom.js